import type { Meilisearch_Editeur } from '@/lib/api/meilisearch-types';

export const computeEditeurPhoto = (editeur: Meilisearch_Editeur) => {
  if (editeur?.photo) return editeur.photo;

  return 'db1682b1-7784-4992-b9cc-3b9561784949';
};
